import { createSlice } from '@reduxjs/toolkit';
import {
  getAttachmentListThunk,
  getAttachmentTypesThunk,
} from './Attachment.thunk';

export const attachmentSlice = createSlice({
  name: 'attachments',
  initialState: {
    types: {
      items: [],
      loading: true,
    },
    list: {
      items: [],
      loading: false,
    },
    selected: {
      item: undefined,
      loading: true,
    },
  },
  reducers: {
    setSelectedAttachmentAction: (state, action) => ({
      ...state,
      selected: {
        ...state.selected,
        item: action.payload,
      },
    }),
    resetAttachmentListAction: (state, action) => ({
      ...state,
      list: {
        ...state.list,
        items: [],
      },
    }),
    resetAttachmentsTypesAction: (state, action) => ({
      ...state,
      types: {
        ...state.types,
        items: [],
      },
    }),
  },
  extraReducers: builder => {
    // Start Attachments Types
    builder.addCase(getAttachmentTypesThunk.pending, (state, action) => {
      state.types = { ...state.types, loading: true };
    });
    builder.addCase(getAttachmentTypesThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.types = { ...state.types, items: data, loading: false };
    });
    builder.addCase(getAttachmentTypesThunk.rejected, (state, action) => {
      // state.types = { ...state.types, loading: false };
    });
    // End Attachments Types
    // Start Attachments List
    builder.addCase(getAttachmentListThunk.pending, (state, action) => {
      state.list = { ...state.list, loading: true };
    });
    builder.addCase(getAttachmentListThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      const items: any = {};
      for (const item of data) {
        const _locState = items[item.target] || [];
        items[item.target] = [..._locState, item];
      }
      state.list = { ...state.list, items, loading: false };
    });
    builder.addCase(getAttachmentListThunk.rejected, (state, action) => {
      // state.list = { ...state.list, loading: false };
    });
    // End Attachments List
  },
});

export const getAttachmentsTypes = (state: any) => state.attachments.types;
export const getAttachmentsList = (state: any) => state.attachments.list;
export const getSelectedAttachment = (state: any) => state.attachments.selected;

export const { setSelectedAttachmentAction, resetAttachmentListAction } =
  attachmentSlice.actions;

export default attachmentSlice.reducer;
